export const mediaFileBuilder = () => {
    const mediaFile = {
        fileName: null,
        description: null,

        setFileName(fileName) {
            this.fileName = fileName
            return this;
        },

        setDescription(description) {
            this.description = description;
            return this;
        },

        build() {
            if (!this.fileName) {
                throw Error('fileName');
            }
            return this;
        },
    };

    return mediaFile;
};